

export class SlabTypeDto implements ISlabTypeDto {
    id!: number | undefined;
    slabType!: string | undefined;
    slabCode!: string | undefined;
    isActive!: boolean;

    constructor(data?: ISlabTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slabType = _data["slabType"];
            this.slabCode = _data["slabCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SlabTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlabTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slabType"] = this.slabType;
        data["slabCode"] = this.slabCode;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ISlabTypeDto {
    id: number | undefined;
    slabType: string | undefined;
    slabCode: string | undefined;
    isActive: boolean;
}

